// extracted by mini-css-extract-plugin
module.exports = {"copyrightWrapper":"CopyrightInSidebar_copyrightWrapper__ChDVK","copyright":"CopyrightInSidebar_copyright__ZaYS3"};